import React, { Fragment } from 'react';
import Modal from '../../../../../components/Modal';
import InfoTable from '../../../../../components/table/InfoTable';
import CountOfTotal from '../../../../../components/CountOfTotal';
import TextAreaForm from '../../../../../components/form/TextAreaForm';
import ImgUpload from '../../../../../components/ImgUpload';
import BaseForm from '../../../../../components/form/BaseForm';
import {
  MAXIMUM_NUMBER_OF_REJECT_DETAIL_IMG,
  MAXIMUM_NUMBER_OF_REJECT_EXCHANGE_REASON_TEXT,
  MINIMUM_HEIGHT_OF_INPUT_REJECT_DETAIL_IMG,
  MINIMUM_WIDTH_OF_INPUT_REJECT_DETAIL_IMG,
  REJECT_DETAIL_IMG_HEIGHT,
  REJECT_DETAIL_IMG_WIDTH,
} from '../../../../../constants/service/app/orderConstants';
import { setNumberWithComma } from '../../../../../lib/common';
import { formRequiredRules } from '../../../../../lib/formRules';
import { IMAGE_SIZE_GUIDE_TEXT, IMAGE_TYPE_GUIDE_TEXT } from '../../../../../constants/service/common/commonConstants';
import './RejectExchangeModal.scss';

const RejectExchangeModal = (props) => {
  const { form, isOpen, data, closeModal, setData, imgUpload, onSubmit, reason, rejectExchangeAttachment } = props;
  const { orderItemId, productName, productPrice } = data;

  return (
    <Modal
      title="교환 거부 처리"
      isOpen={isOpen}
      width={650}
      height={650}
      isFooter={true}
      okText="교환 거부 처리"
      onOk={() => onSubmit()}
      onClose={() => closeModal()}
    >
      <div className="reject-exchange-modal-wrap">
        <div className="reject-exchange-info">
          <div>* 교환 거부 처리 전 구매자에게 먼저 교환 불가 사유를 안내하고, 거부처리를 진행해 주세요.</div>
          <div>* 교환 거부 사유는 구매자에게 별도 안내되므로, 상세히 입력해 주세요.</div>
        </div>

        <div className="title">선택된 상품 주문 리스트</div>

        <InfoTable className="selected-order-item-list-table">
          <thead>
            <tr>
              <th>상품 주문번호</th>
              <th>상품명</th>
              <th>상품 가격(정가)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="tc">{orderItemId}</td>
              <td className="tc">{productName}</td>
              <td className="tc">{setNumberWithComma(productPrice, '원')}</td>
            </tr>
          </tbody>
        </InfoTable>

        <div className="title">변경할 내역</div>

        <InfoTable className="reject-exchange-table">
          <tbody>
            <tr>
              <td className="label tc">
                <span>교환 거부 상세 사유</span>
                <CountOfTotal content={reason} maxCnt={MAXIMUM_NUMBER_OF_REJECT_EXCHANGE_REASON_TEXT} />
              </td>
              <td className="tl" colSpan={3}>
                <TextAreaForm
                  form={form}
                  name="reason"
                  rules={[formRequiredRules(true, null)]}
                  initialValue={reason}
                  onChange={(value) =>
                    setData({
                      name: 'reason',
                      value,
                    })
                  }
                  maxLength={MAXIMUM_NUMBER_OF_REJECT_EXCHANGE_REASON_TEXT}
                />
              </td>
            </tr>
          </tbody>
        </InfoTable>

        <div className="caution-text">** 등록한 사진은 구매자에게 보여집니다.</div>

        <BaseForm
          label={
            <Fragment>
              상세 사진 (옵션)
              <CountOfTotal content={rejectExchangeAttachment} maxCnt={MAXIMUM_NUMBER_OF_REJECT_DETAIL_IMG} />
            </Fragment>
          }
          content={
            <div className="detail-img">
              <ImgUpload
                list={rejectExchangeAttachment}
                maxCnt={MAXIMUM_NUMBER_OF_REJECT_DETAIL_IMG}
                setData={imgUpload}
                targetPath={['rejectExchangeAttachment']}
                targetSize={{
                  width: REJECT_DETAIL_IMG_WIDTH,
                  height: REJECT_DETAIL_IMG_HEIGHT,
                }}
                restriction={{
                  widthMin: MINIMUM_WIDTH_OF_INPUT_REJECT_DETAIL_IMG,
                  heightMin: MINIMUM_HEIGHT_OF_INPUT_REJECT_DETAIL_IMG,
                }}
                name="detailImg"
                cropMode={true}
              />

              {/*사진이 등록되지 않았을때만 가이드 문구를 보이게 한다.*/}
              {!rejectExchangeAttachment.length ? (
                <div className="explain-text">
                  <div>*비율 가로1:세로1</div>
                  <div>*최소 크기: 800 x 800 px (권장 크기보다 작을 경우, 앱에서 화질 저하의 우려가 있습니다.)</div>
                  <div>*{IMAGE_SIZE_GUIDE_TEXT}</div>
                  <div>*{IMAGE_TYPE_GUIDE_TEXT}</div>
                  <div>*상세 이미지는 최대 3개까지 저장할 수 있습니다.</div>
                </div>
              ) : (
                ''
              )}
            </div>
          }
        />

        <div>
          <div>*교환 거부 처리 이후, 판매자는 해당 주문에 대해 변경할 수 있는 상태가 없습니다.</div>
          <div>*APP 에서 구매 확정을 할 수 있습니다. 필요 시, 구매자와 합의를 통해 구매 확정을 요청하세요.</div>
        </div>
      </div>
    </Modal>
  );
};

export default RejectExchangeModal;
